import { UtilityBar } from "@/components/organisms/UtilityBar";

export function ContactsSubnav() {
  return (
    <>
      <UtilityBar />
    </>
  );
}
